import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AppServerAPI } from '@sdbn/common';
import { PendingTaskState } from '../../../transport-list/model';
import { Vehicle, VehicleSelection } from '../../model/sac-client.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { TransportScope } from '../../../../../common/model/transport.model';

@Component({
    selector: 'app-moving-order-vehicle-selection',
    templateUrl: './moving-order-vehicle-selection.component.html',
    styleUrls: ['./moving-order-vehicle-selection.component.scss'],
    standalone: false
})
export class MovingOrderVehicleSelectionComponent implements OnInit {

  readonly TransportScope = TransportScope;
  readonly PendingTaskState = PendingTaskState;

  dataSource: MatTableDataSource<Vehicle> = new MatTableDataSource(new Array<Vehicle>());

  form: FormGroup;

  selection = new VehicleSelection();

  @Input() mode: string;

  @Output() selectedVehicle = new EventEmitter<number>();

  defaultVisibleColumns = [
    'carrier', 'identifier', 'name', 'currentStation'
  ];

  columnsToDisplay = this.defaultVisibleColumns;

  sortColumn = 'start';

  sortDirection: SortDirection = 'asc' as SortDirection;

  selectedListEntry: Vehicle;

  constructor(
    private appServerAPI: AppServerAPI
  ) {
    this.form = new FormGroup({
      query: new FormControl('', [])
    });

    this.form.valueChanges.subscribe(values => {

      this.selection = new VehicleSelection();
      this.selection.query = values.query;

    });

  }

  ngOnInit(): void {
    this.loadVehicles();
  }

  public sortChanged(event) {
  }

  toggleSelection(vehicle: any) {
    this.selectedListEntry = vehicle;
    this.selectedVehicle.next(vehicle.id);
  }

  loadVehicles() {

    this.appServerAPI.execute<any[]>(`/client/control/sac-client/find-vehicles`, this.selection).subscribe(
      vehicles => {

        let data = new Array<Vehicle>();

        for (const vehicle of vehicles) {
          data.push(new Vehicle(vehicle));
        }

        this.dataSource = new MatTableDataSource(data);

      }
    );

  }

  refresh() {
    this.loadVehicles();
  }
}
